<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_vii">To US Army Command Sergeant Major Kevin Griffin, US Army Major Tom Kennedy, US Air Force Major David Gray, USAID Foreign Service Officer Ragaei Abdelfattah, and your families. I will never forget you, nor will the grateful nation for which you made the ultimate sacrifice.</a></p><a id="page_vii">
<p class="dedr"><span class="txbf">—FLO GROBERG</span></p>
<p class="ded1">To my grandparents, Canio and Hedy Sileo and Clarence and Betty Luther. Your sacrifices during World War II helped pave the way for future generations of American heroes.</p>
<p class="dedr"><span class="txbf">—TOM SILEO</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?028fa32c